import {
  Select,
  SelectContent,
  SelectIcon,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { PcmpCodeLabel } from '../../types/pcmpQueue.types';

const ALL_VALUE = '__all__';

interface PcmpCodeSelectProps<T extends string> {
  id: string;
  options: readonly PcmpCodeLabel[] | undefined;
  value: T | undefined;
  onChange: (value: T | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
}

/** A filter select over `{ code, label }` options, with an "All" choice that clears it. */
export function PcmpCodeSelect<T extends string>({
  id,
  options,
  value,
  onChange,
  placeholder = 'All',
  disabled,
}: PcmpCodeSelectProps<T>) {
  const items = [
    { value: ALL_VALUE, label: placeholder },
    ...(options ?? []).map((option) => ({ value: option.code, label: option.label })),
  ];

  return (
    <Select<string>
      items={items}
      value={value ?? ALL_VALUE}
      onValueChange={(next) =>
        onChange(next === ALL_VALUE || next === null ? undefined : (next as T))
      }
      disabled={disabled}
    >
      <SelectTrigger id={id} className="h-10 w-full">
        <SelectValue />
        <SelectIcon />
      </SelectTrigger>
      <SelectContent>
        {items.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
